// extracted by mini-css-extract-plugin
module.exports = {"container":"UserImageEditor__container--1qI3a"};